import { history } from 'containers/App/App';

export const AUTH_PATHS = [
  '/authentication/404',
  '/reset-password',
  '/user/activate',
  '/user/create-password',
  '/login',
  '/forgot-password',
  '/logout',
];

const NON_RESTORABLE_PATHS = ['/', '/home', '/alternate'];

export interface SessionExpiredState {
  sessionExpired: true;
  from?: string;
  companyID?: string;
  userID?: string;
}

export interface RestoreState {
  redirectTo: string;
  companyID?: string;
  userID?: string;
}

const isAuthPath = (pathname?: string): boolean =>
  !!pathname && AUTH_PATHS.some(p => pathname.includes(p));

const getStoredSessionOwner = (): { companyID?: string; userID?: string } => {
  const owner: { companyID?: string; userID?: string } = {};
  const companyID = localStorage.getItem('companyID');
  if (!!companyID && companyID !== 'undefined') {
    owner.companyID = companyID;
  }
  try {
    const raw = localStorage.getItem('loggedInUser');
    const parsed: unknown = raw ? JSON.parse(raw) : null;
    if (typeof parsed === 'object' && parsed !== null && 'ID' in parsed) {
      const id = (parsed as { ID?: unknown }).ID;
      if (typeof id === 'string' && !!id) {
        owner.userID = id;
      }
    }
  } catch {
    // unparsable loggedInUser: guard degrades to unguarded
  }
  return owner;
};

export const getSessionExpiredState = (): SessionExpiredState => {
  const { pathname, search, hash } = history.location;
  if (isAuthPath(pathname)) {
    return { sessionExpired: true };
  }
  return {
    sessionExpired: true,
    from: `${pathname}${search}${hash}`,
    ...getStoredSessionOwner(),
  };
};

export const isRestorablePath = (path?: string | null): path is string => {
  if (!path || typeof path !== 'string') return false;
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  const pathname = path.split('?')[0].split('#')[0];
  if (NON_RESTORABLE_PATHS.includes(pathname)) return false;
  if (isAuthPath(pathname)) return false;
  return true;
};
